import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';

// Section 9 — implementation and expert support.
export const ReachImplementation = ({ sp }) => (
  <section aria-labelledby="reach-implementation-heading" data-testid="reach-implementation" className="bg-mist py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="09"
        eyebrow="Implementation & Support"
        title="Set up around how you actually sell"
        description={sp.implementationCopy}
        testid="reach-implementation-header"
      />
      <ol className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {(sp.stages || []).map((stage, i) => (
          <Reveal key={stage.title} delay={i * 0.08} className="h-full">
            <li className="flex h-full flex-col rounded-xl border border-slate-200 bg-white p-6" data-testid={`reach-stage-${i + 1}`}>
              <span className="font-mono text-sm font-bold tracking-widest text-service-growth">{String(i + 1).padStart(2, '0')}</span>
              <h3 className="mt-3 text-lg font-extrabold tracking-tight text-navy-900">{stage.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{stage.text}</p>
            </li>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
